export default __webpack_public_path__ + "static/media/penalty.4919b8fc.png";